import { connectRouter, LocationChangeAction, RouterState } from 'connected-react-router';
import { History } from 'history';
import { Action, AnyAction, combineReducers, Dispatch } from 'redux';
import * as effects from "redux-saga/effects";
import { reducer as UIReducer } from "redux-ui";
import { Reducer } from 'typesafe-actions';
import { DashboardReducer } from "./Dashboard/Reducer";
import { DashboardSaga } from "./Dashboard/Sagas";
import { IDashboardState } from "./Dashboard/Types";
import { ElectionReducer } from "./Elections/Reducer";
import { ElectionsSaga } from "./Elections/Sagas";
import { IElectionsState } from "./Elections/Types";
import { ExportReducer } from "./Export/Reducer";
import { ExportSaga } from "./Export/Sagas";
import { IExportState } from "./Export/Types";
import { I18NReducer } from './I18n/Reducer';
import { I18NSaga } from './I18n/Sagas';
import { I18NState } from "./I18n/Types";
import { LayoutReducer } from './Layout/Reducer';
import { LayoutSaga } from './Layout/Sagas';
import { ILayoutState } from './Layout/Types';
import { PlayerReducer } from "./Player/Reducer";
import { PlayerSaga } from "./Player/Sagas";
import { IPlayerState } from "./Player/Types";
import { PoliticalRegimeReducer } from "./PoliticalRegime/Reducer";
import { PoliticalRegimeSaga } from "./PoliticalRegime/Sagas";
import { IPoliticalRegimeState } from "./PoliticalRegime/Types";
import { SearchReducer } from './Search/Reducer';
import { SearchSaga } from './Search/Sagas';
import { ISearchState } from "./Search/Types";
import { StatsReducer } from './Statistics/Reducer';
import { StatsSaga } from './Statistics/Sagas';
import { IStatsState } from "./Statistics/Types";
import { UserReducer } from "./User/Reducer";
import { UserSaga } from "./User/Sagas";
import { IUserState } from "./User/Types";

export interface IApplicationState {
  i18n: I18NState;
  layout: ILayoutState;
  router: RouterState;
  user: IUserState;
  dashboard: IDashboardState;
  search: ISearchState;
  player: IPlayerState;
  ui: any;
  stats: IStatsState;
  file: IExportState;
  elections: IElectionsState;
  politicalRegime: IPoliticalRegimeState;
}

export interface IConnectedReduxProps<A extends Action = AnyAction> {
    dispatch: Dispatch<A>;
}

export const RootReducer = (history: History) =>
  combineReducers<IApplicationState>({
    i18n: I18NReducer,
    layout: LayoutReducer,
    ui: UIReducer,
    router: connectRouter(history) as Reducer<
      RouterState,
      LocationChangeAction
    >,
    user: UserReducer,
    dashboard: DashboardReducer,
    search: SearchReducer,
    player: PlayerReducer,
    stats: StatsReducer,
    file: ExportReducer,
    elections: ElectionReducer,
    politicalRegime: PoliticalRegimeReducer,
  });

export function* RootSaga() {
    yield effects.all([
      effects.fork(I18NSaga),
      effects.fork(LayoutSaga),
      effects.fork(UserSaga),
      effects.fork(DashboardSaga),
      effects.fork(SearchSaga),
      effects.fork(PlayerSaga),
      effects.fork(StatsSaga),
      effects.fork(ExportSaga),
      effects.fork(ElectionsSaga),
      effects.fork(PoliticalRegimeSaga),
    ]);
}
